import {
  NetworkStatus,
  type QueryHookOptions,
  useApolloClient,
} from '@apollo/client';
import * as Sentry from '@sentry/react';
import {
  MeDocument,
  type MeQuery,
  type MeQueryVariables,
  type MeUserFragment,
  useMeQuery,
} from 'api/core/generated';
import { AppApiVersions } from 'app-constants';

export const useGetUser = (
  options?: QueryHookOptions<MeQuery, MeQueryVariables>,
) => {
  const client = useApolloClient();
  const { data, loading, error, refetch, networkStatus } = useMeQuery({
    ...options,
    context: { apiVersion: AppApiVersions.core },
    onError: (error) => {
      Sentry.captureException('Cannot get user', { data: error });
    },
  });

  const getUser = () => refetch();

  const quietUserRefetch = async () => {
    const result = await client.query<MeQuery>({
      query: MeDocument,
      context: { apiVersion: AppApiVersions.core },
      fetchPolicy: 'network-only',
    });
    return result.data.me;
  };

  return {
    user: data?.me as MeUserFragment,
    userLoading: loading,
    userError: error,
    userWasFetched: networkStatus === NetworkStatus.ready,
    getUser,
    quietUserRefetch,
  };
};
